import React from 'react';
import './call-us-section.scss';

const CallUs = () => {
  return (
    <div id="call-us-section">
      <p className="instruction-text" data-cy="call-us-instructions">
        Any questions? Want to find out more?
        Give us a call and our team will be happy to help...
      </p>
      <div className="number" data-cy="office-phone-number">
        <a href="tel:01822820740">01822 820740</a> /
        <a href="tel:01822820699"> 01822 820699</a>
      </div>
    </div>
  );
};

export default CallUs;
